﻿<template>
    <li>
        <component :is="tag" v-bind="$attrs" class="dropdown-item-text">
            <span v-text="text" />
        </component>
    </li>
</template>

<script lang="ts">

import {defineComponent} from "vue";

export default defineComponent({
    name: "AunoaDropdownItemText",
    inheritAttrs: false,
    props: {
        tag: {
            type: String,
            default: "div"
        },
        text: {
            type: String
        }
    }
});

</script>

